import React, { useEffect, useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Badge,
} from "reactstrap"
import { useNavigate, useParams, Link } from "react-router-dom"
import classnames from "classnames"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import axios from "axios"
import toastr from "toastr"
import "toastr/build/toastr.min.css"
import Select from "react-select"
import apiURl from "url"
// import "./RiderWallet.css"

const RiderWallet = () => {
  document.title = "Rider Wallet"
  const navigate = useNavigate()
  const { rider_id } = useParams()

  const [walletData, setWalletData] = useState([])
  const [riderBalance, setRiderBalance] = useState("0.00")
  const [pendingAmount, setPendingAmount] = useState("0.00")
  const [completedAmount, setCompletedAmount] = useState("0.00")
  const [pendingRiderCharges, setPendingRiderCharges] = useState("0.00")
  const [completedRiderCharges, setCompletedRiderCharges] = useState("0.00")
  const [loading, setLoading] = useState(false)
  const [filter, setFilter] = useState({
    rider_id: "",
    start_date: "",
    end_date: "",
  })
  const [riderName, setRiderName] = useState(null)
  const [riderOptions, setRiderOptions] = useState([])
  const [selectedRider, setSelectedRider] = useState(null)
  const [activeTab, setActiveTab] = useState("1")
  const [modal, setModal] = useState(false)
  const [paymentAmount, setPaymentAmount] = useState("")

  const toggleModal = () => setModal(!modal)

  const getApprovedRiders = async () => {
    try {
      const URL = `${apiURl}/getApprovedRiders`
      const response = await axios.get(URL)
      if (response.data.status === "success") {
        const rideroption = response.data.riders.map(row => ({
          label: row.name,
          value: row.id,
        }))
        setRiderOptions(rideroption)
        if (rider_id) {
          const selected = rideroption.find(
            option => option.value === parseInt(rider_id)
          )
          if (selected) {
            setSelectedRider(selected)
            setFilter(prev => ({ ...prev, rider_id: parseInt(rider_id) }))

            setRiderName(selected.label)
          } else {
            toastr.error("Rider not found")
          }
        }
      } else {
        toastr.error("Failed to fetch riders")
      }
    } catch (error) {
      console.error("Error fetching riders:", error)
      toastr.error("Error fetching riders")
    }
  }

  const fetchWalletData = async () => {
    if (!filter.rider_id) {
      setWalletData([])
      setRiderBalance("0.00")
      setPendingAmount("0.00")
      setCompletedAmount("0.00")
      setPendingRiderCharges("0.00")
      setCompletedRiderCharges("0.00")
      return
    }
    setLoading(true)
    const URL = `${apiURl}/fetchRiderJobs`
    const params = {
      rider_id: filter.rider_id,
      start_date: filter.start_date,
      end_date: filter.end_date,
    }
    try {
      const response = await axios.get(URL, { params })
      if (response.data.status === "success") {
        const transactions = response.data.parcelDetailsByID
        setWalletData(transactions)
        const completedJobs = transactions.filter(
          job => job.rider_status === "completed"
        )
        const pendingJobs = transactions.filter(
          job => job.rider_status !== "completed"
        )
        const totalBalance = completedJobs.reduce(
          (sum, job) => sum + parseFloat(job.rider_charges || 0),
          0
        )
        const pendingAmountTotal = pendingJobs.reduce(
          (sum, job) => sum + calculateTotalAmount(job),
          0
        )
        const completedAmountTotal = completedJobs.reduce(
          (sum, job) => sum + calculateTotalAmount(job),
          0
        )
        const pendingRiderChargesTotal = pendingJobs.reduce(
          (sum, job) => sum + parseFloat(job.rider_charges || 0),
          0
        )
        const completedRiderChargesTotal = completedJobs.reduce(
          (sum, job) => sum + parseFloat(job.rider_charges || 0),
          0
        )
        setRiderBalance(totalBalance.toFixed(2))
        setPendingAmount(pendingAmountTotal.toFixed(2))
        setCompletedAmount(completedAmountTotal.toFixed(2))
        setPendingRiderCharges(pendingRiderChargesTotal.toFixed(2))
        setCompletedRiderCharges(completedRiderChargesTotal.toFixed(2))
      } else {
        toastr.error("Failed to fetch rider jobs")
        setWalletData([])
        setRiderBalance("0.00")
        setPendingAmount("0.00")
        setCompletedAmount("0.00")
        setPendingRiderCharges("0.00")
        setCompletedRiderCharges("0.00")
      }
    } catch (error) {
      console.error("Error fetching rider jobs:", error)
      toastr.error("Error fetching rider jobs")
      setWalletData([])
      setRiderBalance("0.00")
      setPendingAmount("0.00")
      setCompletedAmount("0.00")
      setPendingRiderCharges("0.00")
      setCompletedRiderCharges("0.00")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getApprovedRiders()
  }, [])

  useEffect(() => {
    fetchWalletData()
  }, [filter])

  const handleFilterChange = e => {
    const { name, value } = e.target
    setFilter(prev => ({ ...prev, [name]: value }))
  }

  const handleRiderChange = selectedOption => {
    setSelectedRider(selectedOption)
    setFilter(prev => ({
      ...prev,
      rider_id: selectedOption ? selectedOption.value : "",
    }))
    setRiderName(selectedOption.label)
  }

  const handleReset = () => {
    setFilter({
      rider_id: "",
      start_date: "",
      end_date: "",
    })
    setSelectedRider(null)
    setWalletData([])
    setRiderBalance("0.00")
    setPendingAmount("0.00")
    setCompletedAmount("0.00")
    setPendingRiderCharges("0.00")
    setCompletedRiderCharges("0.00")
    setRiderName(null)
  }

  const handlePaymentSubmit = async () => {
    if (!paymentAmount || parseFloat(paymentAmount) <= 0) {
      toastr.error("Please enter a valid payment amount")
      return
    }
    try {
      const URL = `${apiURl}/payRider`
      const response = await axios.post(URL, {
        rider_id: filter.rider_id,
        amount: parseFloat(paymentAmount),
      })
      if (response.data.status === "success") {
        toastr.success("Payment processed successfully")
        setPaymentAmount("")
        toggleModal()
        fetchWalletData()
      } else {
        toastr.error("Failed to process payment")
      }
    } catch (error) {
      console.error("Error processing payment:", error)
      toastr.error("Error processing payment")
    }
  }

  const toggleTab = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  const calculateTotalAmount = job => {
    const parcelAmount = parseFloat(job.total_price) || 0
    const documentAmount = parseFloat(job.docs_total_price) || 0
    const depChargesAmount = parseFloat(job.dep_charges_amount) || 0
    const parcelCviAmount = parseFloat(job.parcel_price) || 0
    const docCviAmount = parseFloat(job.doc_cvi_amount) || 0
    const riderCharges = parseFloat(job.rider_charges) || 0
    const parcelCviPercent = parcelCviAmount * 0.025
    const docCviPercent = docCviAmount * 0.025

    let PA_FOR_GST =
      (parcelAmount - parcelCviPercent - riderCharges) * 0.15 + parcelAmount
    let DA_FOR_GST =
      (documentAmount - docCviPercent - riderCharges) * 0.15 + documentAmount
    DA_FOR_GST += depChargesAmount

    return job.service_name === "Docs. Attestation" ? DA_FOR_GST : PA_FOR_GST
  }

  const renderJobCard = (job, index) => {
    const rowStyle = {
      backgroundColor: job.rider_status === "completed" ? "#d4edda" : "#f8d7da", // light green / light red
      borderRadius: "4px",
      padding: "20px",
    }

    return (
      <Card key={job.track_id} className="mb-3 shadow-sm border-0">
        <CardBody style={rowStyle}>
          <Row>
            <Col md="3">
              <strong>Track ID:</strong> {job.track_id}
            </Col>
            <Col md="3">
              <strong>Date:</strong>{" "}
              {new Date(job.created_date).toLocaleDateString()}
            </Col>
            <Col md="3">
              <strong>Total Amount:</strong> PKR{" "}
              {calculateTotalAmount(job).toFixed(2)}
            </Col>
            <Col md="3">
              <strong>Rider Charges:</strong> PKR {job.rider_charges}
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md="3">
              <strong>Status:</strong> {job.status_}
            </Col>
            <Col md="3">
              <strong>Sender:</strong> {job.sender_full_name} (
              {job.sender_phone})
            </Col>
            <Col md="3">
              <strong>Receiver:</strong> {job.receiver_full_name} (
              {job.receiver_phone || "N/A"})
            </Col>
          </Row>
        </CardBody>
      </Card>
    )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row className="mb-3">
            <Col xl="6">
              <div className="">
                <h6 className="card-title mb-0">
                  {riderName ? (
                    <>
                      <span className="text-primary">
                        <Badge
                          pill
                          className="badge-soft-primary ms-1 font-size-14"
                        >
                          {riderName}
                        </Badge>
                      </span>{" "}
                      Wallet
                    </>
                  ) : (
                    "Rider Wallet"
                  )}
                </h6>
              </div>
            </Col>
            <Col xl="6">
              <div className="d-flex justify-content-end">
                <Link
                  to="/rider-management"
                  className="btn btn-outline-secondary btn-sm"
                >
                  ← Back
                </Link>
              </div>
            </Col>
          </Row>

          <Row>
            <Col xl="12">
              <Card className="shadow-sm border-0">
                <CardBody>
                  <CardTitle className="mb-4">Wallet Filters</CardTitle>

                  <Form>
                    <Row>
                      <Col lg="3">
                        <FormGroup className="mb-3">
                          <Label>Rider</Label>

                          <Select
                            value={selectedRider}
                            onChange={handleRiderChange}
                            options={riderOptions}
                            className="select2-selection"
                            placeholder="Select Rider"
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="3">
                        <FormGroup className="mb-3">
                          <Label>Start Date</Label>
                          <Input
                            type="date"
                            name="start_date"
                            value={filter.start_date}
                            onChange={handleFilterChange}
                            className="form-control"
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="3">
                        <FormGroup className="mb-3">
                          <Label>End Date</Label>
                          <Input
                            type="date"
                            name="end_date"
                            value={filter.end_date}
                            onChange={handleFilterChange}
                            className="form-control"
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="3">
                        <div className="">
                          <Button
                            color="primary"
                            onClick={fetchWalletData}
                            disabled={!filter.rider_id || loading}
                            className="me-2 mt-4"
                          >
                            {loading ? "Loading..." : "Apply Filters"}
                          </Button>
                          <Button
                            color="secondary"
                            onClick={handleReset}
                            disabled={loading}
                            className="mt-4"
                          >
                            Reset
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {filter.rider_id && (
            <Row className="mb-4">
              <Col md="6">
                <Card className="shadow-sm border-0">
                  <CardBody>
                    <div className="d-flex align-items-center">
                      <h5 className="card-title mb-0 me-2">Pending Jobs</h5>
                      <Badge pill className="bg-danger font-size-12">
                        {
                          walletData.filter(
                            job => job.rider_status !== "completed"
                          ).length
                        }
                      </Badge>
                    </div>
                    <Row className="mt-4">
                      <Col md="6">
                        <Card
                          className="mini-stats-wid"
                          style={{
                            backgroundColor: "#e6effc",
                            boxShadow:
                              "0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 3px 10px 0 rgba(0, 0, 0, 0.03)",
                          }}
                        >
                          <CardBody>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <p className="text-muted fw-medium">
                                  Amount to Collect
                                </p>
                                <h4 className="mb-0">PKR {pendingAmount}</h4>
                              </div>
                              <div className="avatar-sm rounded-circle bg-danger align-self-center mini-stat-icon">
                                <span className="avatar-title rounded-circle bg-danger">
                                  <i
                                    className={"bx bx-dollar font-size-24"}
                                  ></i>
                                </span>
                              </div>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col md="6">
                        <Card
                          className="mini-stats-wid"
                          style={{
                            backgroundColor: "#e6effc",
                            boxShadow:
                              "0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 3px 10px 0 rgba(0, 0, 0, 0.03)",
                          }}
                        >
                          <CardBody>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <p className="text-muted fw-medium">
                                  Pending Rider Charges
                                </p>
                                <h4 className="mb-0">
                                  PKR {pendingRiderCharges}
                                </h4>
                              </div>
                              <div className="avatar-sm rounded-circle bg-danger align-self-center mini-stat-icon">
                                <span className="avatar-title rounded-circle bg-danger">
                                  <i
                                    className={"bx bx-dollar font-size-24"}
                                  ></i>
                                </span>
                              </div>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col md="6">
                <Card className="shadow-sm border-0">
                  <CardBody>
                    <Row>
                      <Col md="6">
                        <div className="d-flex align-items-center">
                          <h5 className="card-title mb-0 me-2">
                            Completed Jobs
                          </h5>
                          <Badge pill className="bg-success font-size-12">
                            {
                              walletData.filter(
                                job => job.rider_status === "completed"
                              ).length
                            }
                          </Badge>
                        </div>
                      </Col>
                      <Col md="6">
                        <div className="float-end">
                          <Button
                            className="btn btn-sm btn-success"
                            onClick={toggleModal}
                            disabled={
                              !filter.rider_id ||
                              parseFloat(completedRiderCharges) <= 0
                            }
                          >
                            Pay to Rider
                          </Button>
                        </div>
                      </Col>
                    </Row>
                    <Row className="mt-4">
                      <Col md="6">
                        <Card
                          className="mini-stats-wid"
                          style={{
                            backgroundColor: "#e6effc",
                            boxShadow:
                              "0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 3px 10px 0 rgba(0, 0, 0, 0.03)",
                          }}
                        >
                          <CardBody>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <p className="text-muted fw-medium">
                                  Total Amount Collected
                                </p>
                                <h4 className="mb-0">PKR {completedAmount}</h4>
                              </div>
                              <div className="avatar-sm rounded-circle bg-success align-self-center mini-stat-icon">
                                <span className="avatar-title rounded-circle bg-success">
                                  <i
                                    className={"bx bx-dollar font-size-24"}
                                  ></i>
                                </span>
                              </div>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col md="6">
                        <Card
                          className="mini-stats-wid"
                          style={{
                            backgroundColor: "#e6effc",
                            boxShadow:
                              "0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 3px 10px 0 rgba(0, 0, 0, 0.03)",
                          }}
                        >
                          <CardBody>
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <p className="text-muted fw-medium">
                                  Rider Charges (pay)
                                </p>
                                <h4 className="mb-0">
                                  PKR {completedRiderCharges}
                                </h4>
                              </div>
                              <div className="avatar-sm rounded-circle bg-success align-self-center mini-stat-icon">
                                <span className="avatar-title rounded-circle bg-success">
                                  <i
                                    className={"bx bx-dollar font-size-24"}
                                  ></i>
                                </span>
                              </div>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
          <Row>
            <Col xl="12">
              <Card className="shadow-sm border-0">
                <CardBody>
                  <CardTitle>Rider Jobs</CardTitle>
                  <Nav tabs className="nav-tabs-custom">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" })}
                        onClick={() => toggleTab("1")}
                      >
                        All Leads
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" })}
                        onClick={() => toggleTab("2")}
                      >
                        Completed
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" })}
                        onClick={() => toggleTab("3")}
                      >
                        Pending
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <TabContent activeTab={activeTab} className="mt-4">
                    <TabPane tabId="1">
                      {loading ? (
                        <div className="text-center">Loading...</div>
                      ) : walletData.length > 0 ? (
                        walletData.map((job, index) =>
                          renderJobCard(job, index)
                        )
                      ) : (
                        <div className="text-center">No leads found</div>
                      )}
                    </TabPane>
                    <TabPane tabId="2">
                      {loading ? (
                        <div className="text-center">Loading...</div>
                      ) : walletData.filter(
                          job => job.rider_status === "completed"
                        ).length > 0 ? (
                        walletData
                          .filter(job => job.rider_status === "completed")
                          .map((job, index) => renderJobCard(job, index))
                      ) : (
                        <div className="text-center">
                          No completed leads found
                        </div>
                      )}
                    </TabPane>
                    <TabPane tabId="3">
                      {loading ? (
                        <div className="text-center">Loading...</div>
                      ) : walletData.filter(
                          job => job.rider_status !== "completed"
                        ).length > 0 ? (
                        walletData
                          .filter(job => job.rider_status !== "completed")
                          .map((job, index) => renderJobCard(job, index))
                      ) : (
                        <div className="text-center">
                          No Pending leads found
                        </div>
                      )}
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggleModal}>
            <ModalHeader toggle={toggleModal}>Pay to Rider</ModalHeader>
            <ModalBody>
              <Form>
                <FormGroup>
                  <Label for="paymentAmount">Payment Amount (PKR)</Label>
                  <Input
                    type="number"
                    name="paymentAmount"
                    id="paymentAmount"
                    value={paymentAmount}
                    onChange={e => setPaymentAmount(e.target.value)}
                    placeholder="Enter amount to pay"
                    min="0"
                    step="0.01"
                  />
                </FormGroup>
              </Form>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={handlePaymentSubmit}>
                Submit Payment
              </Button>{" "}
              <Button color="secondary" onClick={toggleModal}>
                Cancel
              </Button>
            </ModalFooter>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default RiderWallet
